export const isIeOrEdge = (window, document) => {
  // Internet Explorer 6-11
  const isIE = !!document.documentMode;
  // Edge 20+
  const isEdge = !isIE && !!window.StyleMedia;

  return isIE || isEdge;
};
